import { render, staticRenderFns } from "./SchoolSelectbox.vue?vue&type=template&id=4566a9b2"
import script from "./SchoolSelectbox.vue?vue&type=script&lang=js"
export * from "./SchoolSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports